"use strict";var u=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var t=(n,c,r,a)=>{for(var i=a>1?void 0:a?p(c,r):c,h=n.length-1,l;h>=0;h--)(l=n[h])&&(i=(a?l(c,r,i):l(i))||i);return a&&i&&u(c,r,i),i};import{baseStyles as g,CiscoUElement as o,html as e,nothing as d}from"@cisco-u/base";import{property as s}from"@cisco-u/base/src/decorators.js";import{classMap as k}from"@cisco-u/base/src/directives.js";import"@cisco-u/button/cu-button.js";import"@cisco-u/stickers/cu-stickers.js";import b from"./promo-card.css.js";export class PromoCard extends o{constructor(){super(...arguments);this.headingType="h3";this.heading="Heading Goes Here";this.description="Description Goes Here";this.btnText="Button Text";this.btnType="primary";this.theme="light";this.layout="A"}static get styles(){return[g,b]}render(){const r=this._setClasses();return e`<article class=${k({...r})}>
      ${this._returnBackgroundStickers()} ${this._returnHeading()}
      <p class="description">${this.description}</p>
      <div class="btn-wrapper">
        <cu-button
          template=${this.btnType}
          href=${this.btnLink||d}
          @click=${this._dispatchClickEvent}
          >${this.btnText}</cu-button
        >
      </div>
    </article>`}_setClasses(){return{card:!0,light:this.theme==="light",dark:this.theme==="dark","dark-gray":this.theme==="darkGray"}}_returnBackgroundStickers(){switch(this.layout){case"A":return e`<cu-stickers
            class="blue-sticker"
            bgColor="blue-primary"
            shape="star-2"
            stickerDiameter="2.5rem"
          ></cu-stickers>
          <cu-stickers
            class="red-sticker"
            bgColor="red-primary"
            shape="star-1"
            stickerDiameter="1.25rem"
          ></cu-stickers>
          <cu-stickers
            class="orange-sticker"
            bgColor="orange"
            shape="sleek-rectangle"
            stickerDiameter="2.5rem"
          ></cu-stickers>`;case"B":return e`<cu-stickers
            class="blue-sticker-2"
            bgColor="blue"
            shape="star-1"
            stickerDiameter="4rem"
          ></cu-stickers>
          <cu-stickers
            class="orange-sticker-2"
            bgColor="orange"
            shape="star-2"
            stickerDiameter="8.875rem"
          ></cu-stickers>
          <cu-stickers
            class="ghost-sticker"
            bgColor="white"
            shape="star-2"
            ghost
            stickerBorder="6.5"
            stickerDiameter="7.5625rem"
          ></cu-stickers>`;default:return e``}}_returnHeading(){switch(this.headingType){case"h1":return e`<h1 class="title">${this.heading}</h1>`;case"h2":return e`<h2 class="title">${this.heading}</h2>`;case"h3":return e`<h3 class="title">${this.heading}</h3>`;case"h4":return e`<h4 class="title">${this.heading}</h4>`;case"h5":return e`<h5 class="title">${this.heading}</h5>`;default:return e`<h3 class="title">${this.heading}</h3>`}}_dispatchClickEvent(){const r={headingType:this.headingType,heading:this.heading,description:this.description,btnText:this.btnText,btnType:this.btnType,btnLink:this.btnLink};this.dispatchEvent(new CustomEvent("cu-promo-card",{bubbles:!0,composed:!0,detail:r}))}}t([s({type:String,reflect:!0})],PromoCard.prototype,"headingType",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"heading",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"description",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"btnText",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"btnType",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"btnLink",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"theme",2),t([s({type:String,reflect:!0})],PromoCard.prototype,"layout",2);
//# sourceMappingURL=PromoCard.js.map
